Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.errorCountryCode = "Please select country code";
exports.errorTitle = "Error";
exports.apiSendOtpContentType = "application/json";
exports.apiSendOtpEndPoint =
  "account/accounts/send_otp";

exports.errorMobileNotValid = "Phone number is not valid.";
exports.apiSendOtpMethod = "POST";

exports.placeHolderMobile = "Mobile";
exports.btnTxtSendOtp = "Send me otp";
exports.placeHolderSelectCountry = "Select Country";

exports.bodyText = "Value proposition: why users should sign up.";

exports.labelInfo =
  "We will send a 4 digit OTP to the number below.If the number is incorrect, Change it and resent OTP";
